import usePaymentRedirect from "./usePaymentRedirect";
import {useContext, useState, useEffect} from "react";
import {ReducerStateInterface} from "../../interfaces/core/ReducerStateInterface";
import {GlobalContext} from "../../GlobalReducer";
import {checkFastOrder} from "../../api/checkout";
import {OrderInterface} from "../../interfaces/customer/OrderInterface";
import {useLocation} from "react-router-dom";


export default function FastPaymentLink() {

    const [state, dispatch] = useContext<[ReducerStateInterface, Function]>(GlobalContext);
    const [order, setOrder] = useState<OrderInterface | undefined>(undefined)
    const [error, setError] = useState<string | undefined>(undefined)

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const uid = queryParams.get('uid');

    useEffect(() => {
        if (uid) {
            checkFastOrder(uid).then((response: any) => {
                setOrder(response.order)
            }, (error: any) => {
                setError(error.response?.data?.message || error.response?.data?.detail)
            })
        } else {
            setError('Ссылка на оплату не найдена');
        }
    }, [uid]);

    useEffect(() => {
        const style = document.createElement('style');
        style.textContent = `
      .head-line, header, .mobile-menu, footer, .btn.btn-secondary, .breadcrumb {display: none!important;}
    `;
        document.head.appendChild(style);

        console.log('FastPaymentLink mounted with uid:', uid);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    usePaymentRedirect(order, dispatch)

    return (<section className="page-404 pt" style={{padding: "200px 0"}}>
        {error && <div className="page-404__wrap">
            <h4 className="f-exp">
                Ошибка при переадресации на форму оплаты
            </h4>
            <p>
                {error}
            </p>
        </div>}
    </section>)
}